export default __webpack_public_path__ + "static/media/fuel.61768110.png";